import { appendTestableComponentAttributes, appendTestableElementAttributes } from '@dreryk/react-components';

import { useAudioAnalyser } from '../../audio/useAudioAnalyser';
import { useAudioInputMediaStream } from '../../audio/useAudioInputMediaStream';
import { useAudioLevel } from '../../audio/useAudioLevel';
import { useAiAssistantMicrophoneGlobalState } from '../../shared/useAiAssistantMicrophoneGlobalState';

import {
   StyledMicrophoneLevelFill,
   StyledMicrophoneLevelTrack,
} from './AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneLevel.styled';

export const AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneLevel = (): JSX.Element => {
   const { device } = useAiAssistantMicrophoneGlobalState();
   const mediaStream = useAudioInputMediaStream(device?.id ?? null);
   const analyser = useAudioAnalyser(mediaStream);
   const level = useAudioLevel(analyser);

   return (
      <StyledMicrophoneLevelTrack {...appendTestableComponentAttributes('MicrophoneLevel', 'microphoneLevel')}>
         <StyledMicrophoneLevelFill $level={level} {...appendTestableElementAttributes('fill')} />
      </StyledMicrophoneLevelTrack>
   );
};
